// extracted by mini-css-extract-plugin
module.exports = {"exam_analysis_root_wrapper":"ExamAnalysis_exam_analysis_root_wrapper__3cEqD"};